export default "__VITE_ASSET__DuHW8Ka8__"